export default __webpack_public_path__ + "static/media/ico-calendar-reset.d47f230d.svg";